import React from "react";
import { Row, Col } from "reactstrap";
import Widget02 from "../../Components/Widgets/Widget02";
import { Badge } from "antd";
import { useSelector } from "react-redux";
import { AccessAlarm, FlashOn } from "@material-ui/icons";
import InfoIcon from "../../Assets/external_icons/color/info1.png";
import TotalEnergyIcon from "../../Assets/external_icons/color/energy.png";
import SolarProduction from "../../Assets/external_icons/color/solar-production.png";
import TempIcon from "../../Assets/external_icons/color/hot.png";
import GasEmission from "../../Assets/external_icons/color/gas_emission.png"
import MaximumDataProd from "../../Assets/external_icons/color/renew2.png"
import TotalProd from "../../Assets/external_icons/color/solar-energy.png"
import CO2Icon from "../../Assets/external_icons/color/co2.png";
import moment from "moment-jalaali";

const SmallWidget = (props) => {
  const lang_choiced = useSelector((state) => state.lang_change);
  const {
    BatteryPower,
    prod_index,
    plantTempereture,
    totalPlantProductions,
  } = props;
  const checkStatus = (status) => {
    switch (status) {
      case "unknown":
        return lang_choiced.pages.dashboard.smallWidget.status_text.unknown;
      case "active":
        return lang_choiced.pages.dashboard.smallWidget.status_text.stable;
      case "inactive":
        return lang_choiced.pages.dashboard.smallWidget.status_text.unstable;
      default:
        return lang_choiced.pages.dashboard.smallWidget.status_text.default;
    }
  };
  return (
    <div>
      <Row>
        <Col xs="12" sm="6" lg="3">
          <Widget02
            key="PlantStatus"
            className="small-widget"
            style={{ borderRadius: "4px" }}
            header={checkStatus(prod_index)}
            mainText={<span style={{ fontSize: "13px" }}>{lang_choiced.pages.dashboard.smallWidget.widgets[0].subTitle}</span>}
            icon={<img style={{ width: "40px" }} src={InfoIcon} />}
            color="secondary"
            variant="1"
          />
        </Col>
        <Col xs="12" sm="6" lg="3">
          <Widget02
            key="TotalPLantProductions"
            className="small-widget"
            header={`${totalPlantProductions} kWh`}
            mainText={
              <span style={{ fontSize: "13px" }}> {lang_choiced.pages.dashboard.smallWidget.widgets[1].subTitle} </span>
            }
            icon={<img style={{ width: "40px" }} src={TotalEnergyIcon} />}
            color="secondary"
            variant="1"
            style={{ direction: "ltr" }}
          />
        </Col>
        <Col xs="12" sm="6" lg="3">
          <Widget02
            key="EnergyProduction"
            className="small-widget"
            style={{ borderRadius: "4px", direction: "ltr" }}
            header={
              `${(props.totalYearlyProduction > 1000 ? props.totalYearlyProduction / 1000 : props.totalYearlyProduction)} ${props.totalYearlyProduction > 1000 ? lang_choiced.pages.dashboard.groupWidget.widgets[0].units[1] : lang_choiced.pages.dashboard.groupWidget.widgets[0].units[0]}`
            }
            mainText={<span style={{ fontSize: "13px" }}>{lang_choiced.pages.dashboard.groupWidget.widgets[0].subTitle}</span>}
            icon={<img style={{ width: "40px" }} src={TotalProd} />}
            color="secondary"
            variant="1"
          />
        </Col>

        <Col xs="12" sm="6" lg="3">
          <Widget02
            key="PlantTempereture"
            className="small-widget"
            header={`${plantTempereture ? plantTempereture - 273 : "-"} °C`}
            mainText={<span style={{ fontSize: "13px" }}>{`${lang_choiced.pages.dashboard.smallWidget.widgets[3].subTitle
              } (${window.localStorage.getItem("lang") === "persian"
                ? moment(new Date()).format("jYYYY/jMM/jDD")
                : moment(new Date()).format("YYYY/MM/DD")
              })`}</span>}
            icon={<img style={{ width: "40px" }} src={TempIcon} />}
            color="secondary"
            variant="1"
            style={{ direction: "ltr" }}
          />
        </Col>
      </Row>
      <Row>
        <Col xs="12" sm="6" lg="3">
          <Widget02
            key="BatteryPower"
            className="small-widget"
            header={<span className="ltr">{BatteryPower > 1 || BatteryPower < -1 ? `${(BatteryPower).toFixed(2)} kW` : `${(BatteryPower * 1000).toFixed(0)} W`}</span>}
            mainText={
              <span style={{ fontSize: "13px" }}>{lang_choiced.pages.dashboard.smallWidget.widgets[2].subTitle}</span>
            }
            icon={<img style={{ width: "40px" }} src={SolarProduction} />}
            color="secondary"
            variant="1"
            style={{ direction: "ltr" }}
          />
        </Col>

        <Col xs="12" sm="6" lg="3">
          <Widget02
            key="MaximumPower"
            className="small-widget"
            header={
              `${props.MaximumDataProd > 0 ? props.MaximumDataProd.toFixed(2) : 0} kW`
            }
            mainText={
              <span style={{ fontSize: "13px" }}>  {lang_choiced.pages.dashboard.groupWidget.widgets[1].subTitle} </span>
            }
            icon={<img style={{ width: "40px" }} src={MaximumDataProd} />}
            color="secondary"
            variant="1"
            style={{ direction: "ltr" }}
          />
        </Col>
        <Col xs="12" sm="6" lg="3">
          <Widget02
            key="AlayandehCO2"
            className="small-widget"
            header={
              `${(Math.floor((props.totalPlantProductions) * 640) / 1000).toFixed(2)} ${lang_choiced.pages.dashboard.groupWidget.widgets[2].unit}`
            }
            mainText={
              <span style={{ fontSize: "13px" }}>{lang_choiced.pages.dashboard.groupWidget.widgets[2].subTitle}</span>
            }
            icon={<img style={{ width: "40px" }} src={CO2Icon} />}
            color="secondary"
            variant="1"
            style={{ direction: "ltr" }}
          />
        </Col>
        <Col xs="12" sm="6" lg="3">
          <Widget02
            key="AlayandehMahali"
            className="small-widget"
            header={
              `${(Math.floor((props.totalPlantProductions) * 5.15) / 1000).toFixed(2)} ${lang_choiced.pages.dashboard.groupWidget.widgets[3].unit}`
            }
            mainText={<span style={{ fontSize: "13px", direction: "rtl !important" }}>{lang_choiced.pages.dashboard.groupWidget.widgets[3].subTitle}</span>}
            icon={<img style={{ width: "40px" }} src={GasEmission} />}
            color="secondary"
            variant="1"
            style={{ direction: "ltr" }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default SmallWidget;
